import VSearchInput from './index.vue';

export default {
  install: (Vue) => Vue.component('VSearchInput', VSearchInput),
};
